<template>
  <div class="main">
    <div class="header">
      <el-image
        @click="$router.push('/')"
        v-if="form.logo"
        :src="form.logo"
        fit="scale-down"
        style="display: inline-block"
      ></el-image>
      <h4 @click="$router.push('/')">{{ customer.name }}</h4>
      <div style="display: flex">
        <Navuser />
      </div>
    </div>
    <div class="landing">
      <router-view />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import preferences from "../util/preferences";
import Navuser from "./NavUser";

export default {
  name: "Home",
  components: { Navuser },
  data() {
    return {
      form: { ...preferences() },
    };
  },
  computed: {
    ...mapState("account", ["user", "customer"]),
  },
  methods: {},
};
</script>
<style >
.main {
  min-height: 100vh;
  max-height: 100vh;
  display: flex;
  flex-direction: column;
}
.el-tabs__content {
  overflow: auto;
}
</style>
<style scoped>
.landing {
  flex: 1;
  display: flex;
  overflow: auto;
}

.header {
  display: flex;
  justify-content: space-between;
  color: white;
  align-items: center;
  flex-direction: row;
  background: #343a40;
  padding-left: 30px;
  padding-right: 15px;
  height: 40px;
}
</style>